import { module as Module } from "modujs";
import { whenReady } from "../utils/fonts";
import {FONT} from "../config.js";
import {$screen} from "../stores/screen.js";

export default class extends Module {
    constructor(m) {
        super(m);

        // Binding
        this.onResizeBind = this.onResize.bind(this);

        // UI
        this.$list = this.$('list')[0]
        this.$items = Array.from(this.$list.querySelectorAll("li"))
        this.$lastItems = this.$items.pop()
    }

    ///////////////
    // Lifecycle
    ///////////////
    init() {
        this.bindEvents();

        whenReady(FONT.EAGER).then((fonts) => this.onFontsLoaded(fonts));
    }

    destroy() {
        super.destroy();
        this.unbindEvents();
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        this.unbindScreenListener = $screen.subscribe(this.onResizeBind)
    }

    unbindEvents() {
        this.unbindScreenListener?.()
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.compute();
    }

    onFontsLoaded(fonts) {
        this.compute();
    }

    compute() {
        requestAnimationFrame(() => {
            const height = this.$lastItems.offsetHeight
            this.el.style.setProperty('--last-item-height', `${height}px`);
        })
    }
}
